import './App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routes } from './utils/routes'
import { GoogleMapsProvider } from './utils/googleMaps'

function App() {
  const router = createBrowserRouter(routes)

  return (
    <GoogleMapsProvider>
      <RouterProvider router={router} />
    </GoogleMapsProvider>
  )
}

export default App
